// Scrollable content overlaps the header and footer in the Panel control, these style rules bring them to the front
export const fabricPanelFixStyle = () => ({
  footer: {
    background: 'white',
    borderTop: '1px solid #EDEBE9',
    zIndex: 1,
  },
  commands: {
    marginTop: 0,
    marginBottom: 0,
    zIndex: 1,
  },
});
